import { render, staticRenderFns } from "./ai-train-modal.vue?vue&type=template&id=46a725ac&scoped=true&"
import script from "./ai-train-modal.vue?vue&type=script&lang=js&"
export * from "./ai-train-modal.vue?vue&type=script&lang=js&"
import style0 from "./ai-train-modal.vue?vue&type=style&index=0&id=46a725ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a725ac",
  null
  
)

export default component.exports